import { z } from 'zod';

import { BankruptcyInput } from '../loan/Bankruptcy';
import { StopSettings } from '../loan/StopSettings';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateBankruptcyEvent = BaseLoanEvent.extend({
  type: z.literal('updateBankruptcy'),
  operationType: z.enum(['create', 'update']),
  bankruptcy: BankruptcyInput,
  stopSettings: StopSettings.partial(),
  comment: z.string().optional(),
});
export type UpdateBankruptcyEvent = z.infer<typeof UpdateBankruptcyEvent>;
